import useMiniregRegistration from './useMiniregRegistration';

export default useMiniregRegistration;
